import { configureStore, type Middleware } from '@reduxjs/toolkit'
import { save, load } from 'redux-localstorage-simple'

import application from './application/reducer'
import { updateVersion } from './global/actions'
import user from './user/reducer'
import transactions from './transactions/reducer'
import swap from './swap/reducer'
import mint from './mint/reducer'
import lists from './lists/reducer'
import burn from './burn/reducer'
import multicall from './multicall/reducer'

const PERSISTED_KEYS: string[] = ['user', 'transactions', 'lists']

// Type the redux-localstorage-simple middleware
const saveMiddleware: Middleware<Record<string, never>, unknown, never> = save({ states: PERSISTED_KEYS })

// Define the shape of our root state
const rootReducer = {
  application,
  user,
  transactions,
  swap,
  mint,
  burn,
  multicall,
  lists
}

// Type for preloaded state
type RootState = {
  [K in keyof typeof rootReducer]?: ReturnType<(typeof rootReducer)[K]>
}

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: false }).concat(saveMiddleware),
  preloadedState: load({ states: PERSISTED_KEYS }) as Partial<RootState>
})

store.dispatch(updateVersion())

export default store

export type AppState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
